/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import {
	Pressable,
	View,
	Text,
	ErrorText,
	TextField,
	Image,
	Button,
	Icon,
	Checkbox,
} from '@components/atoms'
import { Footer } from '@components/systems'
import loginBg from '@public/images/pages/customerLogin/login-bg.jpg'

import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch, customerAuthActions } from '@redux/index'

import { produce } from 'immer'
import { grey } from '@mui/material/colors'

const CustomerJoin = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// hook
	const navigate = useNavigate()

	// redux state
	const joinErrorMessage: string = useAppSelector(
		state => state.customerAuth.joinErrorMessage,
	)

	// state
	const [account, setAccount] = React.useState({
		name: '',
		email: '',
		confirmEmailNewsYn: true,
		password: '',
		confirmPassword: '',
	})

	const onNameChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const str = e.target.value
			const newAccount = produce(account, draft => {
				draft.name = str
			})

			setAccount(newAccount)
		},
		[account],
	)

	const onEmailChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const str = e.target.value
			const newAccount = produce(account, draft => {
				draft.email = str
			})

			setAccount(newAccount)
		},
		[account],
	)

	const onConfirmEmailNewsYn = () => {
		const newAccount = produce(account, draft => {
			draft.confirmEmailNewsYn = !account.confirmEmailNewsYn
		})

		setAccount(newAccount)
	}

	const onPwChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const str = e.target.value
			const newAccount = produce(account, draft => {
				draft.password = str
			})

			setAccount(newAccount)
		},
		[account],
	)

	const onConfirmPwChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const str = e.target.value
			const newAccount = produce(account, draft => {
				draft.confirmPassword = str
			})

			setAccount(newAccount)
		},
		[account],
	)

	const onJoinClick = React.useCallback(() => {
		if (
			account.name !== '' &&
			account.email !== '' &&
			account.password !== '' &&
			account.confirmPassword !== ''
		) {
			reduxDispatch(customerAuthActions.JOIN({ ...account }))
		} else {
			reduxDispatch(
				customerAuthActions.JOIN_ERROR_MESSAGE(
					'Please check your join information again.',
				),
			)
		}
	}, [account])

	return (
		<View css={style}>
			<View className="customerLoginOuterView">
				<View className="loginPaper">
					<View className="loginImageView">
						<Image src={loginBg} className="loginImage" />
					</View>

					<View className="loginInputView">
						<Pressable className="backButton" onClick={() => navigate('/customer/login')}>
							<Icon name="arrow-left" className="backButtonIcon" />
						</Pressable>
						<Text category="h4" className="inputTitle">
							Join the Memebership
						</Text>

						<View className="inputView">
							<TextField
								type="text"
								label="Your Name"
								size="small"
								onChange={onNameChange}
							/>
						</View>
						<View className="inputView">
							<TextField
								type="text"
								label="Email"
								size="small"
								onChange={onEmailChange}
							/>

							<View className="confirmEmailNewsYnView">
								<Pressable
									onClick={onConfirmEmailNewsYn}
									className="confirmEmailNewsYnButton"
								>
									<Checkbox checked={account.confirmEmailNewsYn} />
									<Text category="p1">
										Yes, I’d like to receive updates on the latest guitar gear and
										discounts.
									</Text>
								</Pressable>
							</View>
						</View>

						<View className="inputView">
							<TextField
								type="password"
								label="Password"
								size="small"
								onChange={onPwChange}
							/>
						</View>
						<View className="inputView">
							<TextField
								type="password"
								label="Confirm Password"
								size="small"
								onChange={onConfirmPwChange}
							/>
						</View>

						<View className="loginButtonDiv">
							{joinErrorMessage !== '' ? (
								<ErrorText className="errorMsg">{joinErrorMessage}</ErrorText>
							) : null}

							<Button onClick={onJoinClick} className="loginButton" variant="contained">
								Join
							</Button>
						</View>
					</View>
				</View>

				<View className="loginBackgroundView">
					<View className="loginBgView"></View>
					<Image src={loginBg} className="loginBackground" />
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default CustomerJoin

const style = css({
	position: 'relative',
	width: '100%',

	'.customerLoginOuterView': {
		position: 'relative',
		height: 'calc(100vh - 10rem)',
		width: '100%',
		overflow: 'hidden',

		'.loginPaper': {
			position: 'absolute',
			zIndex: 5,
			display: 'flex',
			width: '60rem',
			height: '35rem',
			top: 0,
			bottom: 0,
			right: 0,
			left: 0,
			margin: 'auto',
			background: '#FFF',
			borderRadius: '10px',
			overflow: 'hidden',

			'.loginImageView': {
				width: 'calc(100% - 25rem)',
				overflow: 'hidden',

				'.loginImage': {
					width: 'auto',
					height: '100%',
					marginLeft: '-7rem',
				},
			},

			'.loginInputView': {
				width: '25rem',
				padding: '2rem',
				textAlign: 'left',

				'.backButton': {
					'.backButtonIcon': {},
				},

				'.inputTitle': {
					textAlign: 'center',
				},

				'.inputView': {
					width: '100%',
					marginBottom: '1.2rem',

					'.confirmEmailNewsYnView': {
						'.confirmEmailNewsYnButton': {
							display: 'flex',
							justifyContent: 'flex-start',
							textAlign: 'left',
						},
					},
				},

				'.input': {
					width: '100%',
				},

				'.loginButtonDiv': {
					position: 'relative',
					width: '100%',
					marginBottom: '0.8rem',
					paddingTop: 0,

					'.idSaveView': {
						display: 'flex',
						alignItems: 'center',
					},

					'.loginButton': {
						width: '100%',
						height: '2.6rem',
						background: grey[900],
					},
				},
			},
		},

		'.loginBackgroundView': {
			position: 'absolute',
			zIndex: 0,
			top: 0,
			bottom: 0,
			width: '100%',
			height: 'auto',
			overflow: 'hidden',

			'.loginBgView': {
				position: 'absolute',
				zIndex: 1,
				top: 0,
				bottom: 0,
				width: '100%',
				height: '100%',
				background: grey[900],
				opacity: 0.5,
			},

			'.loginBackground': {
				height: 'auto',
				width: '110%',
				marginTop: '-1rem',
				marginLeft: '-1rem',
				filter: 'blur(10px)',
			},
		},
	},

	'@media (max-width: 1050px)': {
		'.customerLoginOuterView': {
			'.loginPaper': {
				width: 'calc(100% - 4rem)',
			},
		},
	},

	'@media (max-width: 950px)': {
		'.customerLoginOuterView': {
			'.loginPaper': {
				'.loginImageView': {
					width: 'calc(100% - 40vw)',

					'.loginImage': {
						height: '120%',
						marginLeft: '-20vw',
					},
				},

				'.loginInputView': {
					width: '40vw',
				},
			},
			'.loginBackgroundView': {
				'.loginBackground': {
					width: '150%',
				},
			},
		},
	},

	'@media (max-width: 760px)': {
		'.customerLoginOuterView': {
			'.loginPaper': {
				maxWidth: '28rem',
				width: 'calc(100vw - 4rem)',

				'.loginImageView': {
					display: 'none',
				},

				'.loginInputView': {
					width: '100%',
				},
			},
		},
	},

	'@media (max-width: 400px)': {
		'.customerLoginOuterView': {
			'.loginPaper': {
				width: 'calc(100vw - 1rem)',
			},
		},
	},
})
